module.exports = __webpack_public_path__ + "watermark1.5c1e6f9f.png";